import React from 'react';
import ReactDOM from 'react-dom';
import GoogleMapReact from 'google-map-react';

import './Appointment.scss';

import AppointmentScheduler from './AppointmentScheduler/AppointmentScheduler';
import AppointmentCall from './AppointmentCall/AppointmentCall';

const API_KEY = 'AIzaSyBieaitf8vDRHaAc5rE67IAS9Y0--VpP-0';
const defaultProps = {
    zoom: 18
};

const WIDGET_MODES = {
    SCHEDULER: 0,
    CALL: 1,
    JOTFORM: 2
}

export default class Appointment extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        var appointmentView = null;
        var isJotForm = this.props.center.appointmentMode === WIDGET_MODES.JOTFORM;
        
        if (this.props.center.appointmentMode === WIDGET_MODES.SCHEDULER) {
            appointmentView = <AppointmentScheduler center={this.props.center} campaignId={document.getElementById('appointment-wrap').getAttribute("campaignId")} />;
        } else if (this.props.center.appointmentMode === WIDGET_MODES.CALL) {
            appointmentView = <AppointmentCall center={this.props.center} campaignId={document.getElementById('appointment-wrap').getAttribute("campaignId")}/>;
        }

        return (
            <div className="appt-wrapper">
                { !isJotForm && 
                    <div className="appointment">
                        <div className="appointment-widget">
                            {appointmentView}
                        </div>
                        <div className="appointment-map hidden-xs ">
                            <GoogleMapReact
                                apiKey={API_KEY}
                                defaultCenter={this.props.center}
                                defaultZoom={defaultProps.zoom}>
                                <Marker
                                    lat={this.props.center.lat}
                                    lng={this.props.center.lng} />
                            </GoogleMapReact>
                        </div>
                    </div>
                }
                { isJotForm && 
                    <div className="appointment">
                        <div className="appointment-map full-page">
                        <GoogleMapReact
                            apiKey={API_KEY}
                            defaultCenter={this.props.center}
                            defaultZoom={defaultProps.zoom}>
                            <Marker
                                lat={this.props.center.lat}
                                lng={this.props.center.lng} />
                        </GoogleMapReact>
                    </div>
                    </div>}
                

                
            </div>
        );
    }
}

function Marker(props) {
    return (
        <div className="map-marker">
            <img className="marker" src="/images/components/location/location-pin.svg" alt="location-pin"></img>
        </div>
    );
}

let container = document.getElementById('appointment-wrap');
let center = {
    lat: +container.dataset.lat,
    lng: +container.dataset.lng,
    phoneNumber: container.dataset.phone,
    appointmentMode: +container.dataset.appointmentmode,
    appointmentDetails: container.dataset.appointmentdetails
};

ReactDOM.render(
    <Appointment
        center={center}       
    />, container);


// WEBPACK FOOTER //
// ./Src/Appointment/Appointment.jsx